"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get RipplingIntegration () {
        return RipplingIntegration;
    },
    get RipplingLatestPermissionScopeVersion () {
        return RipplingLatestPermissionScopeVersion;
    },
    get RipplingPermissionScopeVersion () {
        return RipplingPermissionScopeVersion;
    },
    get RipplingPermissionScopeVersions () {
        return RipplingPermissionScopeVersions;
    }
});
const _zod = require("zod");
const _integration = require("./integration");
const RipplingPermissionScopeVersions = {
    /** Base permission scope version for Rippling. */ v1: 1,
    /** Extends permission scope to include the "roleState" field. */ v2: 2,
    /** Extends permission scope to include company level data. */ v3: 3
};
const RipplingPermissionScopeVersion = _zod.z.nativeEnum(RipplingPermissionScopeVersions);
const RipplingLatestPermissionScopeVersion = Math.max(...Object.values(RipplingPermissionScopeVersions));
const RipplingIntegration = _integration.IntegrationModel.pick({
    _id: true,
    access_token: true,
    available_fields: true,
    company: true,
    deactivate_users_when_not_present: true,
    last_fetch: true,
    primary_user_id: true,
    refresh_token: true,
    synced_fields: true,
    walkthrough_finished: true
}).extend({
    integration_type: _zod.z.literal("rippling"),
    permission_scope_version: RipplingPermissionScopeVersion
});
